import { FormElement, Field, Form, FormHandle } from '@progress/kendo-react-form'
import { SaveButton } from 'components'
import MessageAlert from 'components/Alerts/MessageAlert/MessageAlert'
import FormInput from 'components/Form/FormInput'
import FormSkeleton from 'components/Form/FormSkeleton'
import { PhoneValidator, RequiredValidator } from 'core/Validators'
import { getErrors } from 'core/helpers'
import { useState, useRef, useEffect } from 'react'
import { Row, Col, Badge } from 'react-bootstrap'
import { useDispatch } from 'react-redux'
import { endLoadingAction } from 'state/actions/appActions'
import { AppDispatch } from 'state/store'
import { AlertMessage } from 'types'
import { V1ApiUsersClient } from 'core/http-common'
import { UserMultiFactorSettingsJoinedDto, MultiFactorTypeEnum, UserMobilePhoneDto } from '@v1UsersApi'

interface IFormState {
    code: string
}

interface IProps {
    onSetup?: Function,
}

const SmsMultiFactorSetupForm = ({ onSetup }: IProps) => {
    const dispatch = useDispatch<AppDispatch>()
    const formRef = useRef<FormHandle>(null)
    const [alert, setAlert] = useState<AlertMessage>()
    const [smsSettings, setSmsSettings] = useState<UserMultiFactorSettingsJoinedDto>()
    const [userMobilePhone, setUserMobilePhone] = useState<UserMobilePhoneDto>()

    const fetch = async () => {
        try {
            let response = await V1ApiUsersClient.getUserMultiFactorSettings()

            const smsSettings = response.data.find(f => f.multiFactorTypeId === MultiFactorTypeEnum.Sms)
            setSmsSettings(smsSettings)

            const results = await V1ApiUsersClient.getUserMobilePhone()
            setUserMobilePhone(results)
        }
        catch (e) {
            setAlert({ variant: 'danger', messages: getErrors(e) })
        }
        finally {
            await dispatch(endLoadingAction())
        }
    }

    useEffect(() => {
        fetch()
    }, [])

    if (smsSettings && !smsSettings.enabled) {
        return (
            <MessageAlert
                alert={{
                    variant: 'danger',
                    messages: ["There isn't a Mobile Phone Number associated with your user account. Please contact DCS Customer Support to add one. 502-326-8413 ext. 367."]
                }}
            />
        )
    }

    return (
        <div>
            {!smsSettings
                ? <FormSkeleton style={{ height: '50px' }} />
                : <span>
                    <img src={smsSettings?.logoUrl} style={{ height: '50px' }} />
                    <b>Text Message</b> {smsSettings?.recommended && <Badge bg={'success'}>Recommended</Badge>}
                </span>
            }

            {!smsSettings
                ? <FormSkeleton style={{ height: '50px' }} />
                : <div>
                    <div>
                        {!userMobilePhone
                            ? <FormSkeleton style={{ width: '100%', height: '50px' }} />
                            : <Form
                                ref={formRef}
                                initialValues={userMobilePhone}
                                key={JSON.stringify(userMobilePhone)}
                                onSubmit={(e) => {
                                    if (onSetup)
                                        onSetup(e)
                                }}
                                render={(formRenderProps) => (
                                    <FormElement>
                                        <div>
                                            <Row className='mb-4'>
                                                <Col xs={12} className='mb-2'>
                                                    <Field
                                                        name='mobilePhoneNumber'
                                                        id='mobilePhoneNumber'
                                                        component={FormInput}
                                                        label='Mobile Phone:'
                                                        validator={[RequiredValidator, PhoneValidator]}
                                                        autoFocus
                                                    />

                                                </Col>
                                                <Col>
                                                    <SaveButton
                                                        className='btn btn-primary btn-lg'
                                                        type='submit'
                                                        disabled={!formRenderProps.allowSubmit}
                                                    >
                                                        Save
                                                    </SaveButton>
                                                </Col>
                                            </Row>
                                        </div>
                                    </FormElement>
                                )}
                            />
                        }
                    </div>

                    <MessageAlert alert={alert} />
                </div>
            }
        </div>
    )
}
export default SmsMultiFactorSetupForm